import { OktaToken } from '../../interfaces/OktaToken';

const EMPTY_TOKENS = { accessToken: null, idToken: null };

/**
 * Reads the current tokens out of Okta's token storage.
 *
 * Returns nulls rather than throwing. Partially populated storage is real, not
 * defensive padding: a failed renewal makes okta-auth-js delete only the failing
 * key. The TypeError that used to cause wasn't classifiable as an auth error, so
 * React Query retried it instead of signing out. See SAW-10974.
 */
export const getOktaTokens = (): {
  accessToken: Nullable<string>;
  idToken: Nullable<string>;
} => {
  const oktaStorage: Nullable<string> =
    localStorage.getItem('okta-token-storage');

  if (!oktaStorage) {
    return EMPTY_TOKENS;
  }

  let token: Partial<OktaToken>;
  try {
    token = JSON.parse(oktaStorage) as Partial<OktaToken>;
  } catch (error) {
    console.error('Failed to parse okta-token-storage:', error);
    return EMPTY_TOKENS;
  }

  return {
    accessToken: token?.accessToken?.accessToken ?? null,
    idToken: token?.idToken?.idToken ?? null,
  };
};
